import React, { useEffect, useState } from 'react';
import Header from './Header';
import coins from '../assets/images/coins.svg';
import GiftConfigurationService from '../services/gift_configuration.service';
import useApi from '../hooks/useApi';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const Gift = () => {
  const [gifts, setGifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const api = useApi();
  const { t, i18n } = useTranslation('gift');
  const navigate = useNavigate()


  useEffect(() => {
    const fetchGifts = async () => {
      try {
        const today = new Date().toISOString();
        const response = await GiftConfigurationService.index({ valid_until: `gte:${today}`, is_active: 1, with: 'media', sort: 'ordering' }, api);
        setGifts(response);
      } catch (err) {
        setError('Failed to fetch gifts');
      } finally {
        setLoading(false);
      }
    };

    fetchGifts();
  }, []);

  if (loading) {
    return <div>{t('gift:loading')}</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }
  const handleGiftClick = (gift) => {
    console.log("Navigating with gift data:", gift);
    navigate('/buy-voucher', { state: { selectedGift: gift } });
  };

  // helper to read string or translation object
  const getLocalized = (val) => {
    if (val === null || val === undefined) return '';
    if (typeof val === 'string') return val;
    if (typeof val === 'object') {
      const lang = i18n?.language || 'en';
      return val[lang] || val.fr || val.en || '';
    }
    return String(val);
  };

  const resolveGiftImageSrc = (gift) => {
    const mediaUrl = gift?.media?.[0]?.original_url;
    return typeof mediaUrl === 'string' && mediaUrl.trim().length > 0 ? mediaUrl : coins;
  };

  const handleGiftImageError = (event) => {
    if (event.currentTarget.dataset.fallbackApplied === 'true') {
      return;
    }

    event.currentTarget.dataset.fallbackApplied = 'true';
    event.currentTarget.src = coins;
  };

  return (
    <>
      <Header />
      <div className="container gift-options-container gift-page">
        <h2>{t('gift:gift_category')}</h2>

        {gifts && gifts.length > 0 ? (
          gifts.map((gift) => (
            <div className="gift-option" key={gift.id} onClick={() => handleGiftClick(gift)}>
              <div className="gift-option__icon">
                <img
                  src={resolveGiftImageSrc(gift)}
                  alt={getLocalized(gift.name) || 'Gift'}
                  onError={handleGiftImageError}
                />
              </div>
              <div className="gift-option__content">
                <h3>{getLocalized(gift.name)}</h3>
                <h4>{getLocalized(gift.description)}</h4>
                <a>{t('gift:more_info')} &rsaquo;</a>
              </div>
            </div>
          ))
        ) : (
          <p>{t('gift:no_gifts_available')}</p>
        )}
      </div>
    </>
  );
}

export default Gift;
